/* eslint-disable class-methods-use-this */
import { AuthorizationType, AuthorizationStrategy } from "./types";
import { AccessPinStrategy } from "./strategies/AccessPinStrategy";
import { EventPasswordStrategy } from "./strategies/EventPasswordStrategy";
import { TicketTypePasswordStrategy } from "./strategies/TicketTypePasswordStrategy";

export class AuthorizationManager {
  private strategies = new Map<AuthorizationType, AuthorizationStrategy>();

  constructor(strategies?: Map<AuthorizationType, AuthorizationStrategy>) {
    this.strategies = strategies ?? this.createDefaultStrategies();
  }

  private createDefaultStrategies(): Map<
    AuthorizationType,
    AuthorizationStrategy
  > {
    return new Map<AuthorizationType, AuthorizationStrategy>([
      [AuthorizationType.EVENT_PASSWORD, new EventPasswordStrategy()],
      [
        AuthorizationType.TICKET_TYPE_PASSWORD,
        new TicketTypePasswordStrategy(),
      ],
      [AuthorizationType.ACCESS_PIN, new AccessPinStrategy()],
    ]);
  }

  get(type: AuthorizationType): AuthorizationStrategy | undefined {
    return this.strategies.get(type);
  }
}
